// src/states/form.state.ts
import { create, createStore } from 'zustand';

export type ITasklistTask = {
  assignee: string;
  username?: string | null;
  camunda_form?: unknown[];
  form_key: string;
  id: string;
  name: string;
  process_definition_id?: string;
  process_name?: string;
  process_instance_id: string;
  task_definition_key: string;
  variables: { [key: string]: any };
  instance_history?: unknown;
  created_date?: string;
  due_date?: string;
  priority?: number;
};


export type AlurkerjaFormContext = {
  task?: ITasklistTask;
  taskId?: string;
  processDefinitionKey?: string;
  [key: string]: any;
}



export type FormBuilderTab = 'input' | 'detail';
export type PreviewMode = 'full-form' | 'split' | 'full-preview';

interface FormEditorState {
  currentSpec : any[], 
  currentUsertask: {
    id?: string;
    [key: string]: any;
  } | null,
  setCurrentUsertask : (usertask : {} | null) => void,
  setCurrentSpec : (spec : any[]) => void,
  modeler: any,
  setModeler: (modeler: any) => void,
  editorReady : boolean,
  setEditorReady : (ready: boolean) => void,
  axiosInstance: any,
  setAxiosInstance: (instance: any) => void,
  usertasks: any[],
  setAvaiableUsertasks: (usertasks: any[]) => void,
  context: AlurkerjaFormContext ,
  setContext: (context: AlurkerjaFormContext) => void,
  activeFormTab: FormBuilderTab,
  setActiveFormTab: (tab: FormBuilderTab) => void,
  previewMode: PreviewMode,
  setPreviewMode: (mode: PreviewMode) => void,
}

const useFormEditorState = create<FormEditorState>((set) => ({
  currentSpec : [],
  currentUsertask: null,
  setCurrentUsertask : (usertask : {} | null) => set({currentUsertask: usertask}),
  setCurrentSpec : (spec : any[]) => set({currentSpec: spec}),
  modeler: null,
  setModeler: (modeler: any) => set({modeler}),
  editorReady: false,
  setEditorReady: (ready: boolean) => set({editorReady: ready}),
  axiosInstance: null,
  setAxiosInstance: (instance: any) => set({axiosInstance: instance}),
  usertasks: [],
  setAvaiableUsertasks: (usertasks: any[]) => {
    console.log('Setting available usertasks:', usertasks);
    set({usertasks});
  },
  context: {},
  setContext: (context: Record<string, any>) => set({context}),
  activeFormTab: 'input',
  setActiveFormTab: (tab: FormBuilderTab) => set({ activeFormTab: tab }),
  previewMode: 'split',
  setPreviewMode: (mode: PreviewMode) => set({ previewMode: mode }),
}));

export default useFormEditorState